<template>
    <v-simple-table dense>
        <tbody>
            <tr>
                <td>Aktif</td>
                <td>{{ enrollment.is_active ? 'Ya' : 'Tidak' }}</td>
            </tr>
            <tr>
                <td>Mendaftar</td>
                <td>{{ enrolledAt }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import moment from '@/plugins/moment'

export default {
    props: {
        enrollment: {
            type: Object,
            required: true,
        }
    },

    computed: {
        enrolledAt() {
            return moment(this.enrollment.enrolledAt).formatShortDayAndTime()
        }
    }
}
</script>
